import React, { useState, useMemo,useEffect,useRef } from 'react';
import "./Bookings.css";
import Card from './Card/Card';
import editIcon from "../../assets/icons/userEdit.svg"
import RequestCard from './RequestCard/RequestCard';
import CheckInCard from "./CheckInCard/CheckInCard";
import EarlyCheckInCard from './EarlyCheckInCard/EarlyCheckInCard';
import BookingNavbar from './Navbar/BookingNavbar';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useNavigate,useLocation } from 'react-router-dom';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { setCabRequests } from '../../redux/userSlice';
import { setUserId } from '../../redux/userSlice';

// User Authentication
import useAuth from "../../customHooks/useAuth.js";
import DinningCard from './DinningCard/DiningCard.jsx';
import HouseKeepingCard from './HouseKeepingCard/HouseKeepingCard.jsx';
import PostTaxiCard from './PostTaxiCard/PostTaxiCard.jsx';
import TableBookingCard from './TableBookingCard/TableBookingCard.jsx';
import RoomChangeCard from './RoomChangeCard/RoomChangeCard.jsx';
import WakeUpCallCard from './WakeUpCallCard/WakeUpCallCard.jsx';
import ConferenceCard from './ConferenceCard/ConferenceCard.jsx';
import CustomCard from './CustomCard/CustomCard.jsx';
import LateCheckoutCard from './LateCheckoutCard/LateCheckoutCard.jsx';
import WifiCard from './WifiCard/WifiCard.jsx';
import CheckOutCard from './CheckOutCard/CheckOutCard.jsx';
import SpaCard from './SpaCard/SpaCard.jsx';
import PageLoader from '../../assets/pageLoader/PageLoader.js';
import CheckInInvite from './CheckInInvite/CheckInInvite.jsx';



// Base URL
import { baseUrl } from '../../common/baseUrl';

// Icons 
import discountIcon from "../../assets/icons/tokenIcon.png";
import logOutIcon from "../../assets/icons/logout.png"
import { clearSession } from "../../auth/session";
import ReviewsModal from '../components/Reviews/ReviewsModal.jsx';

// Axios Instance
import axiosInstance from '../../axiosInstance/axiosInstance.js';
import JoinBookingModal from './JoinBookingModal/JoinBookingModal.jsx';
import { fetchBookings, bookingsQueryKey, BOOKINGS_STALE_TIME } from '../../common/bookings';
import RestaurantDiningCard from './RestaurantDiningCard/RestaurantDiningCard';


// Fetch Cab Requests
const fetchCabRequests = async (userId) => {
  try{
    const response = await axiosInstance.get(`/api/v1/users/${userId}/requests`);
    

    const requests = response?.data?.data || [];

    // Merge The Request For WebCheckIn
    const result = requests.reduce((acc,item)=>{

      if(item.type==="Web Checkin")
      {
        // Check if an entry for this bookingId and type already exists
        let existingEntry = acc.find(
          (entry) => entry.booking_id === item.booking_id && entry.type ===  item.type
        );
  
        // If no entry exists, create a new one
        if (!existingEntry) {
          existingEntry = {
            user_id : item.user_id,
            booking_number_of_people : item.booking_number_of_people,
            booking_checkin_date : item.booking_checkin_date,
            booking_checkout_date : item.booking_checkout_date,
            hotel_id : item.hotel_id,
            hotel_name : item.hotel_name,
            type: item.type,
            booking_id: item.booking_id,
            hotel_address : item.hotel_address,
            updated_at : item.updated_at,
            status: item.status, // temporary; will update based on conditions
            request: [],
            rating : item.rating,
            rating_remark : item.rating_remark,
            booked_room_id : item.booked_room_id,
            is_rating_given : item.is_rating_given,
            guestRequestId : item.id,
          };
          acc.push(existingEntry);
        } else {
          // If an entry exists, update it if the current item has a more recent updated_at
          if (new Date(item.updated_at) > new Date(existingEntry.updated_at)) {
            existingEntry.updated_at = item.updated_at;
          }
        }
  
        // Add the current item to the `request` array
        existingEntry.request.push({ id: item.id, status: item.status,remarks : item.remarks,
          bookedRoomId : item.booked_room_id 
        });

       
  
        // Update the `common_status` if the current item has `Pending_Hotel`
        // Set common_status to "Pending_Hotel" if any item has that status
        if(existingEntry.request.some(req=>req.status==="Pending_Guest") && existingEntry.request.some(req=>req.status==="Pending_Hotel")){
          
          existingEntry.status ="Combine";
        }
        else if (existingEntry.request.some(req => req.status === "Pending_Hotel")) {
          existingEntry.status = "Pending_Hotel";
        }
        else if (!existingEntry.request.some(req => req.status === "Pending_Hotel")) {
          if(existingEntry.request.some(req => req.status === "Pending_Guest")){
            existingEntry.status = "Pending_Guest";
          }
          else{

            existingEntry.status = item.status;
          }

        }
       


        return acc;
      
      }else{
        // console.log("acc before push : ",acc);
        acc.push(item);
      }
      return acc;
    },[]);

     


    // Sort the requests by the updated_at field in descending order (latest first)
    // const sortedRequests = requests.sort((a, b) => {
    //   return new Date(b.updated_at) - new Date(a.updated_at);
    // });

    const sortedRequests = result.sort((a, b) => {
      return new Date(b.updated_at) - new Date(a.updated_at);
    });
 
    return sortedRequests; 
  }
  catch(error){
    console.log(error);
    return [];
  }
};

export default function Bookings() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // userId
  let userId = localStorage.getItem("user_id")
  let tab = location?.state?.activeTab || ""
 
  const [activeTab, setActiveTab] = useState(tab!=="Ongoing" ? "All" : 'Ongoing'); // Initial active tab is "All"
  const [navbarActive, setNavbarActive] = useState('myBookings'); // Control navbar active state
 

  // Active Request Status
  const checkRequestActive = location.state?.activeRequests || "";

  // Booking Status
  const bookingNavStatus = location.state?.bookingsNav || "";
  const activeTabStatus = location.state?.activeTab || "";

  // useEffect to update navbarActive state after the component renders
  useEffect(() => {
    if (checkRequestActive === "requests") {
      setNavbarActive("requests");
    }
  }, [checkRequestActive]);  // Dependency on `checkRequestActive`


  // For Booking Status
  useEffect(()=>{
    if(bookingNavStatus && activeTabStatus){
      setNavbarActive("myBookings");
      setActiveTab(activeTabStatus)
    }
    
  },[bookingNavStatus,activeTabStatus]);


  // If Active Tab Pending Guest and Pending Hotel then make bookings All Active
  useEffect(()=>{
    if(navbarActive==="myBookings"){
      if(activeTab==="Pending Guest" || activeTab==="Pending Hotel"){
        setActiveTab("All");
      }
    }
  },[activeTab,navbarActive])
   
  
 
  // Refresh Handle   
  useAuth();
 

  // Fetch bookings using React Query
  const { data: cards = [], isLoading: bookingsLoading } = useQuery({
    queryKey: bookingsQueryKey(userId),
    queryFn: () => fetchBookings(userId),
    enabled: !!userId,
    refetchOnWindowFocus: true,
    staleTime: BOOKINGS_STALE_TIME,
    refetchInterval:  4000,  // Refetch every 2 seconds
    onSuccess: (newBookings) => {
      // 'newBookings' is the latest data fetched from the API
      if (JSON.stringify(newBookings) !== JSON.stringify(cards)) {
        console.log("Bookings data has changed!");
      }
    },

    onError: (error) => {
      // Log or handle the error
      console.error("Error fetching bookkings:", error);
    }

  });
 
  // Fetch  requests using React Query and update Redux if there's a change
  const { data: cabRequests = [], isLoading: requestsLoading   } = useQuery({
    queryKey: ['cabRequests', userId],
    queryFn: () => fetchCabRequests(userId),
    enabled: !!userId,
    staleTime: 5000,  // Cache for 5s
    refetchOnWindowFocus: true,
    refetchInterval:  4000,    // Refetch every 1.5 seconds
    // onSuccess: (newCabRequests) => {
    
    //   if (JSON.stringify(newCabRequests) !== JSON.stringify(cabRequest)) {
    //     console.log("Data Changed Successfully As Per Status of Request Change")
    //     dispatch(setCabRequests(newCabRequests)); // Update Redux
    //   }
    // },
    onError: (error) => {
      // Log or handle the error
      console.error("Error fetching requests:", error);
    }
  });


  // Active Tab Changing
  // useEffect(() => {
  //   const checkItOut = ()=>{
  //     try{
  //       if(navbarActive==="myBookings"){
  //         const hasOngoing = cards.some(card => card.current_user_status === 'ONGOING');
  //         // console.log("Has Ongoing : ",hasOngoing)
  //         setActiveTab(hasOngoing ? 'All' : 'Ongoing');
  //       }else{
  //         setActiveTab("All")
  //       }
  //     }catch(error){
  //       console.log(error)
  //     }
  //   }
  //   checkItOut();
  // }, []);// Single run


  // Filter the bookings cards
  const filteredCards = useMemo(() => {
    return cards.filter(card => {
      if (activeTab === 'All') {
        return true;
      }
      return card.current_user_status === activeTab.toUpperCase();
    });
  }, [cards, activeTab]);


  // Filter  requests based on active tab
  const filteredRequests = useMemo(() => {
    return cabRequests.filter(request => {
      if (activeTab === 'All') {
        return true; // Show all requests
      }
      
      else {
        let status = "";
        if (request.status === "Scheduled_Hotel") {
          status = "UPCOMING";
        }

        if(request.status==="Pending_Guest" || (request.status === "Combine" && activeTab === "Pending Guest") ){
          status = "PENDING GUEST";
        }
        if(request.status==="Pending_Hotel" || (request.status === "Combine" && activeTab === "Pending Hotel")){
          status = "PENDING HOTEL";
        }
        if (request.status === "InProgress_Hotel") {
          status = "ONGOING";
        }

        if (
          request.status === "Completed_Hotel" ||
          request.status === "Declined_Hotel" ||
          request.status === "Declined_Guest" ||
          request.status === "Closed_Guest" || 
          request.status === "Closed_Hotel" 
        ) {
          status = "PAST";
        }
        return status.toUpperCase() === activeTab.toUpperCase();
      }
    });
  }, [cabRequests, activeTab]);



  // if (bookingsLoading || requestsLoading) {
  //   return <div style={{
  //     display : 'flex',
  //     justifyContent : 'center',
  //     alignItems : 'center',
  //     margin : 'auto',
  //     width : '100%',
  //     overflow : 'hidden',
  //     height : '100vh',
  //   }}>

  //     <div className="loaderImg">
  //       {/* <img src={loader} alt="" /> */}
  //       <PageLoader/>
  //     </div>


  //   </div>;
  // }


  // Getting Name from the Cookie
  const getNameFromCookie = ()=>{
    const name = localStorage.getItem('userName');
  
    if(name){
      return name;
    }
  };


  // Editting the profile
  const editUserProfile = async()=>{
    try{
      const response = await axiosInstance.get(`/api/v1/users/${userId}`);

      // console.log("Getting Response For Update User :",response.data);

      navigate("/editUserProfile",{state : {
        name : response.data.name,
        email : response.data.email,
        phone : response.data.contact,
        verification_id : response.data.verification_id,
        address : response.data.address
      }
      });

    }catch(error){
      console.log(error);
    }
  }


  // Go to Discount page
  const goToDiscount = ()=>{
    navigate("/discount");
  }

  const logoutUser = () => {
    try {
      // console.log("Here in Logout");
      
      clearSession();
      navigate("/")
  
    } catch (error) {
      console.log(error);
    }
  }


  // For Rating
  const [isReviewModal,setIsReviewModal] = useState(false);
  const [requestData,setRequestData] = useState({});

  // For Join a Booking
  const [isJoinModal,setIsJoinModal] = useState(false);

  const openJoinBookingModal = ()=>{
    try{
      setIsJoinModal(!isJoinModal);
    }catch(error){
      console.log(error)
    }
  }

  // A guest with no bookings can only get in with a code, so open the join
  // modal for them once instead of leaving them on an empty list. The last
  // known answer is remembered so the guest who keeps landing here empty gets
  // the modal on mount rather than after the bookings request comes back.
  const joinPromptShown = useRef(false);
  const emptyFlagKey = `no_bookings_${userId}`;

  const promptJoin = ()=>{
    if(joinPromptShown.current) return;
    joinPromptShown.current = true;
    setIsJoinModal(true);
  }

  useEffect(()=>{
    if(localStorage.getItem(emptyFlagKey)==="1"){
      promptJoin();
    }
  },[emptyFlagKey]);

  useEffect(()=>{
    if(bookingsLoading) return;
    localStorage.setItem(emptyFlagKey, cards.length===0 ? "1" : "0");
    if(cards.length===0){
      promptJoin();
    }
  },[bookingsLoading,cards.length,emptyFlagKey]);


  // console.log("Cab Requests : ",cabRequests);


  return (
    <>
      <div className="bookings">
        {/* Hero */}
        <div className="hero">
          
          <div className='hero-item'>
            <div className="hero-booking">
            
            <h2>
              Hi, {getNameFromCookie() || "Guest"}
            </h2>

            <h3>{navbarActive === 'myBookings' ? "Your Bookings" : "Your Requests"}</h3>
            </div>

            <div className="hero-edit">
              <img src={editIcon} alt="Error" onClick={editUserProfile} />
              {/* <img src={discountIcon} className='disocountIcon' alt="Error" onClick={()=>goToDiscount()} /> */}
            </div>
          </div>

          {/* Logout */}
          <div className='buttons-booking'>
            <div className='logout-user' >
              <img src={logOutIcon} alt="Error" onClick={()=>logoutUser()} />
              <h4 onClick={()=>logoutUser()}>Logout</h4>
            </div>
            <div className='logout-user'>
              <h4 onClick={()=>openJoinBookingModal()}>
                Join Booking
              </h4>
            </div>

          </div>

      

        </div>

        {/* Tabs */}
        <div className="bookings-tabs">

        {
          (navbarActive === 'myBookings' 
            ? ['All', 'Past', 'Ongoing', 'Upcoming'] 
            : ['All', 'Past', 'Ongoing', 'Upcoming', 'Pending Hotel', 'Pending Guest']
          ).map((tab,index) => (
            <span
              key = {index}
              className={`booking-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </span>
          ))
        }

        
        </div>


        {/* Booking Hotel Cards or Cab Requests */}
        <div style={{ paddingBottom: "135px" }}>
          
          
          {
            navbarActive === 'myBookings' && (
              filteredCards.length > 0 ? (
                filteredCards.map(card => (
                  <Card
                    key={card.id}
                    hotelId={card.hotel_id}
                    bookingId={card.id}
                    hotelName={card.hotel_details.name}
                    hotelAddress={card.hotel_details.address}
                    people={card.number_of_people}
                    checkInDate={card.checkin_date}
                    checkOutDate={card.checkout_date}
                    guestDetailsId={card.guest_details_id}
                    userId={userId}
                    status={card.current_user_status}
                    activeTab={activeTab}
                    booking_code = {card?.booking_code || ""}
                    data = {card}
                  />
                ))
              ) : (
                <div style={{display:"flex",justifyContent:"center",alignItems:"center",margin:"auto",minHeight:"50vh",width:"100%"}}>
                  {
                    activeTab === "Ongoing" ? <p style={{padding : "10px",textAlign : "center"}}>
                     No active booking found. Please use the phone number given at reception, or join with your booking invite code below
                     <br />
                     <button className='join-booking-btn' onClick={()=>openJoinBookingModal()}>
                      Join Booking
                     </button>
                    </p> : <p>
                      No Booking Found
                    </p>
                  }
                </div>
              )
            )
          }

 
          {
            navbarActive === 'requests' &&
            cabRequests.length > 0 &&
            filteredRequests.map((request,index) => {
              if (request.type === "Web Checkin") {
                return (
                  <CheckInCard
                    key={index}
                    userId={request.user_id}
                    bookingId={request.booking_id}         
                    status={request.status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}
                    rooms = {request.request}
                    activeTab = {activeTab}
                    bookedRoomId={request.booked_room_id}
                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.guestRequestId}
                    setRequestData = {setRequestData}       
                  />
                );
              } else if (request.type === "PreCheckin Early Checkin Request") {
                // console.log("Early CheckIn Request Data : ",request);
                return (
                  <EarlyCheckInCard    
                    key={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date} 

                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData}  
                  />
                );
              }
              else if(request.type === "In Room Dining"){
                return(
                <DinningCard
                  key={request.id}
                  userId={request.user_id}
                  bookingId={request.booking_id}
                  bookedRoomId={request.booked_room_id}
                  staffRemarks={request.staff_remarks}
                  requestId={request.id}
                  status={request.status}
                  staff_status={request.staff_status}
                  hotelId={request.hotel_id}
                  hotelName={request.hotel_name}
                  hotelAddress={request.hotel_address}
                  people={request.booking_number_of_people}
                  checkInDate={request.booking_checkin_date}
                  checkOutDate={request.booking_checkout_date}
                  staffStatus = {request.staff_status}

                  // For Rating
                  isReviewModal = {isReviewModal}
                  setIsReviewModal = {setIsReviewModal}
                  rating_remark = {request.rating_remark}
                  rating = {request.rating}
                  is_rating_given = {request.is_rating_given}
                  guestRequestId = {request.id}
                  setRequestData = {setRequestData}  
                />)
              }
              else if(request.type === "Restaurant Dining"){
                return(
                <RestaurantDiningCard
                  key={request.id}
                  userId={request.user_id}
                  bookingId={request.booking_id}
                  bookedRoomId={request.booked_room_id}
                  staffRemarks={request.staff_remarks}
                  requestId={request.id}
                  status={request.status}
                  staff_status={request.staff_status}
                  hotelId={request.hotel_id}
                  hotelName={request.hotel_name}
                  hotelAddress={request.hotel_address}
                  people={request.booking_number_of_people}
                  checkInDate={request.booking_checkin_date}
                  checkOutDate={request.booking_checkout_date}
                  staffStatus = {request.staff_status}

                  // For Rating
                  isReviewModal = {isReviewModal}
                  setIsReviewModal = {setIsReviewModal}
                  rating_remark = {request.rating_remark}
                  rating = {request.rating}
                  is_rating_given = {request.is_rating_given}
                  guestRequestId = {request.id}
                  setRequestData = {setRequestData}  
                />)
              }
              else if(request.type==="HouseKeeping"){

                return(
                  <HouseKeepingCard
                  key={request.id}
                  userId={request.user_id}
                  bookingId={request.booking_id}
                  bookedRoomId={request.booked_room_id}
                  staffRemarks={request.staff_remarks}
                  requestId={request.id}
                  status={request.status}
                  staff_status={request.staff_status}
                  hotelId={request.hotel_id}
                  hotelName={request.hotel_name}
                  hotelAddress={request.hotel_address}
                  people={request.booking_number_of_people}
                  checkInDate={request.booking_checkin_date}
                  checkOutDate={request.booking_checkout_date}
                  staffStatus = {request.staff_status}

                  // For Rating
                  isReviewModal = {isReviewModal}
                  setIsReviewModal = {setIsReviewModal}
                  rating_remark = {request.rating_remark}
                  rating = {request.rating}
                  is_rating_given = {request.is_rating_given}
                  guestRequestId = {request.id}
                  setRequestData = {setRequestData}  


                />)
              }

              else if(request.type==="PostCheckin Cab Request"){
                return (
                  <PostTaxiCard
                    key={request.id}
                    id={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}

                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData}  


                  />
                );
              }

              else if(request.type==="Restaurant Table"){
                return (
                  <TableBookingCard
                    key={request.id}
                    id={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}

                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData}  

                  />
                );
              }
              else if(request.type==="PostCheckin Room Change Request"){
                return(
                  <RoomChangeCard
                    key={request.id}
                    id={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}
                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData}  
                  /> 
                )
              }

              else if(request.type==="Wake Up Call"){
                return(
                  <WakeUpCallCard
                    key={request.id}
                    id={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}
                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData} 
                  />
                )
              }
              else if(request.type==="Conference Room"){
                return(
                  <ConferenceCard 
                    key={request.id}
                    id={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}
                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData} 
                  />
                )
              }
              else if(request.type==="Custom Request"){

                return(
                  <CustomCard
                    key={request.id}
                    id={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}
                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData} 
                  />
                )
              }
              else if(request.type==="PostCheckin Late Checkout Request"){
                return(
                  <LateCheckoutCard
                    key={request.id}
                    id={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}
                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData} 
                  />
                )
              }
              else if(request.type==="Get Wifi"){
                return(
                  <WifiCard
                    key={request.id}
                    id={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}
                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData} 
                  />
                )
              }
              else if(request.type==="Checkout"){
                return(
                  <CheckOutCard
                    key={request.id}
                    id={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}
                    roomNumber = {request.room_number}  
                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData} 

                  />
                )
              }

              else if(request.type ==="Spa")
              {
                return(
                  <SpaCard
                    key={request.id}
                    id={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}
                    bookingPeople = {request.booking_number_of_people}
                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData} 
                                     
                  />
                )
              }
              else if(request.type==="Web Checkin Invite"){
                return <CheckInInvite
                  key={request.id}
                  id={request.id}
                  userId={request.user_id}
                  bookingId={request.booking_id}
                  bookedRoomId={request.booked_room_id}
                  staffRemarks={request.staff_remarks}
                  requestId={request.id}
                  status={request.status}
                  staff_status={request.staff_status}
                  hotelId={request.hotel_id}
                  hotelName={request.hotel_name}
                  hotelAddress={request.hotel_address}
                  people={request.booking_number_of_people}
                  checkInDate={request.booking_checkin_date}
                  checkOutDate={request.booking_checkout_date}
                  bookingPeople = {request.booking_number_of_people}
                  // For Rating
                  isReviewModal = {isReviewModal}
                  setIsReviewModal = {setIsReviewModal}
                  rating_remark = {request.rating_remark}
                  rating = {request.rating}
                  is_rating_given = {request.is_rating_given}
                  guestRequestId = {request.id}
                  setRequestData = {setRequestData} 
                />
              }

              else {
                return (
                  <RequestCard
                    key={request.id}
                    id={request.id}
                    userId={request.user_id}
                    bookingId={request.booking_id}
                    bookedRoomId={request.booked_room_id}
                    staffRemarks={request.staff_remarks}
                    requestId={request.id}
                    status={request.status}
                    staff_status={request.staff_status}
                    hotelId={request.hotel_id}
                    hotelName={request.hotel_name}
                    hotelAddress={request.hotel_address}
                    people={request.booking_number_of_people}
                    checkInDate={request.booking_checkin_date}
                    checkOutDate={request.booking_checkout_date}
                    // For Rating
                    isReviewModal = {isReviewModal}
                    setIsReviewModal = {setIsReviewModal}
                    rating_remark = {request.rating_remark}
                    rating = {request.rating}
                    is_rating_given = {request.is_rating_given}
                    guestRequestId = {request.id}
                    setRequestData = {setRequestData} 
                  />
                );
              }
            })
          }




        </div>



      </div>
      {
        isReviewModal && <ReviewsModal isReviewModal={isReviewModal} setIsReviewModal={setIsReviewModal}
          requestData = {requestData}
          setRequestData = {setRequestData}
        />
      }
      {
        isJoinModal && <JoinBookingModal
          setIsJoinModal = {setIsJoinModal}
        />
        
      }

      {/* Navbar */}
      <BookingNavbar navbarActive={navbarActive} setNavbarActive={setNavbarActive} />
    </>
  );
}
